const contactForm = () => {
  if (exists('.page-contact')) {
    $(document).ready(function() {

      $(".submit_contact_form").on("click", function(e) {
        e.preventDefault();

        const form = document.getElementById('contact-form');
        const data = new FormData(form);

        if ($('#contact-form')[0].checkValidity()) {

          console.log('attempting submit');

          ajax(form.method, "https://formspree.io/xedrndqm", data, success, function() {});
          
        } else {
          form.reportValidity();
        }
      });

    });
  }
}

function success() {
  $('.contact-column').first().hide();
  $('.contact-success').show();
}

function ajax(method, url, data, success, error) {
  var xhr = new XMLHttpRequest();
  xhr.open(method, url);
  xhr.setRequestHeader("Accept", "application/json");
  xhr.onreadystatechange = function() {
    if (xhr.readyState !== XMLHttpRequest.DONE) return;
    if (xhr.status === 200) {
      success(xhr.response, xhr.responseType);
    } else {
      error(xhr.status, xhr.response, xhr.responseType);
    }
  };
  xhr.send(data);
}

window.addEventListener('load', function() {
  contactForm();
});